// extracted by mini-css-extract-plugin
export var main = "wall-painting-template-module--main--Jvpri";
export var navArrow = "wall-painting-template-module--nav-arrow--6RsJJ";
export var next = "wall-painting-template-module--next--YXlV9";
export var paintingImage = "wall-painting-template-module--painting-image--yUnRk";
export var paintingInfo = "wall-painting-template-module--painting-info--84BZI";
export var paintingNav = "wall-painting-template-module--painting-nav--zIiBf";
export var paintingNavLink = "wall-painting-template-module--painting-nav-link--dt9ys";
export var paintingTitle = "wall-painting-template-module--painting-title--zLMeb";